export enum NomicEmbeddingsModels {
  NOMIC_EMBED_TEXT = "nomic-embed-text",
}

export const NomicEmbeddingsModelsEnabled = [NomicEmbeddingsModels.NOMIC_EMBED_TEXT]
